import { LOGOUT } from "@/components/access/ducks/Actions"
import { RECEIVE_USER_SEARCH_FINAL } from "@/components/search/ducks/Actions"

const defaultState = {
  secondaryWealthAggregations: [],
  wealthAggregations: [],
  originalQueryTotal: 0,
}

const adminWealthReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case RECEIVE_USER_SEARCH_FINAL: {
      const { response } = action
      // if (response.page !== 0 || response.query !== store.getState().search.user.query) {
      if (response.page !== 0 || response.query !== action.oldQuery) {
        return oldState
      }

      return {
        ...oldState,
        secondaryWealthAggregations: response.secondaryWealth || [],
        wealthAggregations: response.primaryWealth || [],
        originalQueryTotal: response.primaryTotal || 0,
      }
    }

    default:
      return oldState
  }
}

export default adminWealthReducer
